import type { SkipInputAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { StoneFlickingCoreState } from "../types/game-state";
import {
  isParticipantActive,
  isParticipantKnown,
} from "../utils/participant-helpers";

export function validateSkipInput(
  state: StoneFlickingCoreState,
  action: SkipInputAction,
): ValidationResult {
  if (state.phase !== "INPUT_PHASE") {
    return { valid: false, error: "Not in input phase" };
  }

  if (!isParticipantKnown(state.participants, action.participantId)) {
    return { valid: false, error: "Unknown participant" };
  }

  if (
    !isParticipantActive(
      state.participants,
      state.eliminatedParticipants,
      action.participantId,
    )
  ) {
    return { valid: false, error: "Participant is eliminated" };
  }

  if (state.submittedParticipants.includes(action.participantId)) {
    return { valid: false, error: "Already submitted input this round" };
  }

  return { valid: true };
}
